import {Component, computed, inject} from '@angular/core';
import {toSignal} from '@angular/core/rxjs-interop';
import {ActivatedRoute, Router} from '@angular/router';
import {ActivityDTO} from '@domain/activity/activity.dto';
import {LucideAngularModule, Share2Icon} from "lucide-angular";
import {ResponsiveButtonsComponent} from "@shared/container/responsive-buttons/responsive-buttons.component";
import {
  ActivitySearchService
} from '@public/activity/search-activity/components/activity-search-filters/activity-search.service';
import {RouteGenerator} from '@core/route-generator';
import {UI_ROUTES} from '@core/ui.routes';
import {ActivityUtil} from '@domain/activity/activity.util';
import {NotificationService} from '@shared/notification/notification.service';
import {BrowserService} from '@core/service/browser.service';
import {ActivityDisplayComponent} from '@domain/activity/component/activity-display/activity-display.component';
import {HostUtil} from '@domain/host/host.util';

@Component({
  selector: 'app-public-activity-home',
  imports: [
    LucideAngularModule,
    ResponsiveButtonsComponent,
    ActivityDisplayComponent
  ],
  templateUrl: './activity-home.component.html'
})
export class ActivityHomeComponent {

  private readonly route = inject(ActivatedRoute);
  private readonly data = toSignal(this.route.data);
  public readonly activity = computed(() => this.data()?.activity as ActivityDTO);

  protected readonly hasMessaging = computed(() => !!this.activity()?.mainHost?.messaging);
  protected readonly hostUrl = computed(() => {
    const host = this.activity()?.mainHost ?? null;
    const slug = HostUtil.getSlug(host);
    return slug ? RouteGenerator.abs(UI_ROUTES.public.host.home, {slug: slug}) : null;
  });

  private readonly router = inject(Router);
  private readonly searchService = inject(ActivitySearchService);
  private readonly notifyService = inject(NotificationService);
  private readonly browserService = inject(BrowserService);

  public readonly routes = {
    home: RouteGenerator.abs(UI_ROUTES.public.dashboard),
    search: RouteGenerator.abs(UI_ROUTES.public.activity.search)
  };

  public readonly icons = {
    share: Share2Icon
  };

  public close(): void {
    const search = this.searchService.getSearchResponse();
    if (!!search) {
      this.router.navigate(
        [this.routes.search],
        {
          queryParams: search.search
        }
      ).then(_ok =>  {});
    } else {
      this.router.navigate([this.routes.home]).then(_ok =>  {});
    }
  }

  public share(): void {
    const slugUrl = this.getUrl();
    if (!slugUrl) {
      return;
    }
    if (this.browserService.copyToClipboard(slugUrl)) {
      this.notifyService.toast({
        message: `C'est copié: partage cette adresse pour montrer ton activité.`
      });
    }
  }

  private getUrl(): string | null {
    const slug = ActivityUtil.getSlug(this.activity());
    if (!slug) {
      return null;
    }
    return RouteGenerator.uiUrl(UI_ROUTES.public.activity.home, {slug: slug});
  }


}
